import { Roles } from '@client/graphql/__generated__/types';
import { Navigate, Outlet } from 'react-router-dom';
import { useSignUpOnboarding } from '~/apps/consumer/hooks/useSignUpOnboarding';
import { SwitchUser } from '~/common/components/SwitchUser/SwitchUser';
import { GlobalHooks } from '~/common/copilot/GlobalHooks';
import { useAppContext } from '../../contexts/AppContext';

export const Authenticated = () => {
  const { isAuthenticated, user, hasRoles } = useAppContext();
  const { isOnboardingCompleted, isOnboardingStarted } = useSignUpOnboarding();

  if (!isAuthenticated) {
    return (
      <Navigate
        replace
        to={{
          pathname: '/auth/login',
          search: `?next=${window.location.pathname}`,
        }}
      />
    );
  }

  if (!hasRoles || (isOnboardingStarted() && !isOnboardingCompleted())) {
    return <Navigate to="/auth/signup" />;
  }

  return (
    <>
      <Outlet />
      <GlobalHooks />
      {window.ENVS.environment !== 'production' &&
        (user?.roles.includes(Roles.ADMIN) || !!window.ENVS.switchedUser) && (
          <SwitchUser />
        )}
    </>
  );
};
